import { render, staticRenderFns } from "./InvoiceAdditionalFields.vue?vue&type=template&id=464bf525&scoped=true"
import script from "./InvoiceAdditionalFields.vue?vue&type=script&lang=js"
export * from "./InvoiceAdditionalFields.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAdditionalFields.vue?vue&type=style&index=0&id=464bf525&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bf525",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464bf525')) {
      api.createRecord('464bf525', component.options)
    } else {
      api.reload('464bf525', component.options)
    }
    module.hot.accept("./InvoiceAdditionalFields.vue?vue&type=template&id=464bf525&scoped=true", function () {
      api.rerender('464bf525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/DocumentsSettings/InvoiceAdditionalFields.vue"
export default component.exports